<ui-form [config]="validationsFormConfig">
</ui-form>